import axios from "axios";
import apiUrlOne from "../Config";

export const getDashboard = async () => {
    const response = await axios.get(
        `${apiUrlOne}/dashboard/getdashboard`,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};
